import yaml from 'js-yaml';

export type HighlightQuadrant = 'tl' | 'tr' | 'bl' | 'br';

type MediaItemBase = {
  duration?: number; // seconds
  skipCapture?: boolean;
  highlightQuadrant?: HighlightQuadrant;
};

export type MediaItem =
  | (MediaItemBase & {
      src: string;
      type: 'image' | 'video';
    })
  | (MediaItemBase & {
      type: 'pair';
      leftSrc: string;
      rightSrc: string;
    });

export interface GalleryConfig {
  media: MediaItem[];
}

export async function loadGalleryConfig(path = '/gallery-config.yaml'): Promise<GalleryConfig> {
  const res = await fetch(path);
  if (!res.ok) {
    throw new Error(`Failed to fetch gallery config: ${res.statusText}`);
  }
  const text = await res.text();
  return yaml.load(text) as GalleryConfig;
}
